import { render, staticRenderFns } from "./Sumbangan.vue?vue&type=template&id=931f504a&"
import script from "./Sumbangan.vue?vue&type=script&lang=js&"
export * from "./Sumbangan.vue?vue&type=script&lang=js&"
import style0 from "./Sumbangan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports